<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">店舗マスタ</span>
			</div>
			<div class="uk-navbar-right">
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<template v-if="APP_NAME == 'rfms'">
					<button class="uk-button uk-button-primary" @click="showCreateFormDialog">店舗追加</button>
				</template>
				<button class="uk-button uk-button-default" @click="returnButton">戻る</button>
			</div>
		</div>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-overflow-auto">
				<table id="shop_table" class="uk-table uk-table-expand uk-table-striped">
					<thead>
					<tr>
						<th>No.</th>
						<th>部門</th>
						<th>部門コード</th>
						<th>部</th>
						<th>部コード</th>
						<th>課</th>
						<th>課コード</th>
						<th>AMエリア</th>
						<th>AMエリアコード</th>
						<th>店舗名</th>
						<th>店舗コード</th>
						<th>管理者ID</th>
						<th>開店時間 (平日)</th>
						<th>閉店時間 (平日)</th>
						<th>開店時間 (土日祝)</th>
						<th>閉店時間 (土日祝)</th>
						<th>連絡先（裏番）</th>
						<th>連絡先（その他）</th>
						<th>リモートID①</th>
						<th>リモートID②</th>
						<th>リモートID③</th>
						<th>有効<br><span style="color: #b9e0d9">※一括選択できます</span><br><input id="bulk_check_action" class="uk-checkbox" type="checkbox" @click="bulkCheckAction"></th>
						<th>更新日</th>
						<th>編集</th>
					</tr>
					</thead>
					<tbody>
					<template v-for="(shop, index) in shops">
						<tr class="data_row" :key="index" :data-id="shop.id">
							<td>{{ shop.id }}</td>
							<td>{{ shop.department_name }}</td>
							<td>{{ shop.department_code }}</td>
							<td>{{ shop.division_name }}</td>
							<td>{{ shop.division_code }}</td>
							<td>{{ shop.section_name }}</td>
							<td>{{ shop.section_code }}</td>
							<td>{{ shop.am_area_name }}</td>
							<td>{{ shop.am_area_code }}</td>
							<td>{{ shop.name }}</td>
							<td>{{ shop.code }}</td>
							<td>{{ shop.admin_staff_number }}</td>
							<td>{{ shop.business_time_start }}</td>
							<td>{{ shop.business_time_end }}</td>
							<td>{{ shop.wn_business_time_start }}</td>
							<td>{{ shop.wn_business_time_end }}</td>

							<td>{{ shop.secret_number_1 }}</td>
							<td>{{ shop.secret_number_2 }}</td>
							<td>{{ shop.remote_number_1 }}</td>
							<td>{{ shop.remote_number_2 }}</td>
							<td>{{ shop.remote_number_3 }}</td>

							<template v-if="shop.status == 0">
								<td><input class="uk-checkbox" name="status" type="checkbox" checked></td>
							</template>
							<template v-else>
								<td><input class="uk-checkbox" name="status" type="checkbox"></td>
							</template>
							<td>{{ shop.updated_at | moment }}</td>
							<td>
								<button class="uk-button uk-button-default" @click="showEditDialog(shop.id)">編集</button>
							</td>
						</tr>
					</template>
					<template v-if="APP_NAME == 'rfms'">
						<tr>
							<td>
								<button class="uk-button uk-button-default" @click="showCreateFormDialog">+</button>
							</td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
							<td></td>
						</tr>
					</template>
					</tbody>
				</table>
			</div>
			<div class="uk-container uk-container-expand uk-margin-small-bottom uk-margin-top">
				<div class="uk-align-right">
					<button class="uk-button uk-button-primary" @click="saveEditShop">保存</button>
				</div>
			</div>
		</div>
		<!--/ Main -->
		<!-- CreateFormDialog -->
		<div id="create_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">追加</h2>
					</div>
					<div class="uk-align-right">
						<button id="create_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="create_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_name">店舗名 (必須)</label>
							<div class="uk-form-controls">
								<input id="create_form_name" class="uk-input" name="name" type="text" placeholder="店舗名を入力してください" maxlength="20">
								<template v-if="typeof this.createFormState.errors.name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_code">店舗コード (必須)</label>
							<div class="uk-form-controls">
								<input id="create_form_code" class="uk-input" name="code" type="text" placeholder="店舗コードを入力してください" maxlength="4">
								<template v-if="typeof this.createFormState.errors.code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_jurisdiction_name">ドコモ管轄</label>
							<div class="uk-form-controls">
								<input id="create_form_jurisdiction_name" class="uk-input" name="jurisdiction_name" type="text" placeholder="ドコモ管轄を入力してください">
								<template v-if="typeof this.createFormState.errors.jurisdiction_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.jurisdiction_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_jurisdiction_code">ドコモ管轄コード</label>
							<div class="uk-form-controls">
								<input id="create_form_jurisdiction_code" class="uk-input" name="jurisdiction_code" type="text" placeholder="ドコモ管轄コードを入力してください">
								<template v-if="typeof this.createFormState.errors.jurisdiction_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.jurisdiction_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_area_name">エリア名</label>
							<div class="uk-form-controls">
								<input id="create_form_area_name" class="uk-input" name="area_name" type="text" placeholder="エリア名を入力してください">
								<template v-if="typeof this.createFormState.errors.area_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.area_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_area_code">エリアコード</label>
							<div class="uk-form-controls">
								<input id="create_form_area_code" class="uk-input" name="area_code" type="text" placeholder="エリアコードを入力してください">
								<template v-if="typeof this.createFormState.errors.area_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.area_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_branch_name">支店名</label>
							<div class="uk-form-controls">
								<input id="create_form_branch_name" class="uk-input" name="branch_name" type="text" placeholder="支店名を入力してください">
								<template v-if="typeof this.createFormState.errors.branch_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.branch_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_branch_code">支店コード</label>
							<div class="uk-form-controls">
								<input id="create_form_branch_code" class="uk-input" name="branch_code" type="text" placeholder="支店コードを入力してください">
								<template v-if="typeof this.createFormState.errors.branch_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.branch_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_department_name">部門名</label>
							<div class="uk-form-controls">
								<input id="create_form_department_name" class="uk-input" name="department_name" type="text" placeholder="部門名を入力してください">
								<template v-if="typeof this.createFormState.errors.department_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.department_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_department_code">部門コード</label>
							<div class="uk-form-controls">
								<input id="create_form_department_code" class="uk-input" name="department_code" type="text" placeholder="部門コードを入力してください">
								<template v-if="typeof this.createFormState.errors.department_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.department_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_division_name">部名</label>
							<div class="uk-form-controls">
								<input id="create_form_division_name" class="uk-input" name="division_name" type="text" placeholder="部名を入力してください">
								<template v-if="typeof this.createFormState.errors.division_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.division_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_division_code">部コード</label>
							<div class="uk-form-controls">
								<input id="create_form_division_code" class="uk-input" name="division_code" type="text" placeholder="部コードを入力してください">
								<template v-if="typeof this.createFormState.errors.division_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.division_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="create_form_section_name">課名</label>
								<div class="uk-form-controls">
									<input id="create_form_section_name" class="uk-input" name="section_name" type="text" placeholder="課名を入力してください">
									<template v-if="typeof this.createFormState.errors.section_name != undefined">
										<template v-for="(error,index) in this.createFormState.errors.section_name">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="create_form_section_code">課コード</label>
								<div class="uk-form-controls">
									<input id="create_form_section_code" class="uk-input" name="section_code" type="text" placeholder="課コードを入力してください">
									<template v-if="typeof this.createFormState.errors.section_code != undefined">
										<template v-for="(error,index) in this.createFormState.errors.section_code">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_am_area_name">AMエリア</label>
							<div class="uk-form-controls">
								<input id="create_form_am_area_name" class="uk-input" name="am_area_name" type="text" placeholder="AMエリア名を入力してください">
								<template v-if="typeof this.createFormState.errors.am_area_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.am_area_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_am_area_code">AMエリアコード</label>
							<div class="uk-form-controls">
								<input id="create_form_am_area_code" class="uk-input" name="am_area_code" type="text" placeholder="AMエリアコードを入力してください">
								<template v-if="typeof this.createFormState.errors.am_area_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.am_area_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_company_name">会社名</label>
							<div class="uk-form-controls">
								<input id="create_form_company_name" class="uk-input" name="company_name" type="text" placeholder="会社名を入力してください">
								<template v-if="typeof this.createFormState.errors.company_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.company_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_company_code">会社コード</label>
							<div class="uk-form-controls">
								<input id="create_form_company_code" class="uk-input" name="company_code" type="text" placeholder="会社コードを入力してください">
								<template v-if="typeof this.createFormState.errors.company_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.company_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_admin_staff_number">管理者ID (必須)</label>
							<div class="uk-form-controls">
								<input id="create_form_admin_staff_number" class="uk-input" name="admin_staff_number" type="text" placeholder="管理者IDを入力してください">
								<template v-if="typeof this.createFormState.errors.admin_staff_number != undefined">
									<template v-for="(error,index) in this.createFormState.errors.admin_staff_number">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_business_time_start">営業開始時間 (平日)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="create_form_business_time_start" v-model="create_form_business_time_start" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="create_form_business_time_start" v-model="create_form_business_time_start" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.business_time_start != undefined">
									<template v-for="(error,index) in this.createFormState.errors.business_time_start">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_business_time_end">営業終了時間 (平日)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="create_form_business_time_end" v-model="create_form_business_time_end" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="create_form_business_time_end" v-model="create_form_business_time_end" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.business_time_end != undefined">
									<template v-for="(error,index) in this.createFormState.errors.business_time_end">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_wn_business_time_start">営業開始時間 (土日祝)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="create_form_wn_business_time_start" v-model="create_form_wn_business_time_start" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="create_form_wn_business_time_start" v-model="create_form_wn_business_time_start" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.wn_business_time_start != undefined">
									<template v-for="(error,index) in this.createFormState.errors.wn_business_time_start">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_wn_business_time_end">営業終了時間 (土日祝)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="create_form_wn_business_time_end" v-model="create_form_wn_business_time_end" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="create_form_wn_business_time_end" v-model="create_form_wn_business_time_end" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeCreateTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.wn_business_time_end != undefined">
									<template v-for="(error,index) in this.createFormState.errors.wn_business_time_end">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_secret_number_1">連絡先（裏番）</label>
							<div class="uk-form-controls">
								<input id="create_form_secret_number_1" class="uk-input" name="secret_number_1" type="text" placeholder="連絡先（裏番）を入力してください">
								<template v-if="typeof this.createFormState.errors.secret_number_1 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.secret_number_1">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_secret_number_2">連絡先（その他）</label>
							<div class="uk-form-controls">
								<input id="create_form_secret_number_2" class="uk-input" name="secret_number_2" type="text" placeholder="連絡先（その他）を入力してください">
								<template v-if="typeof this.createFormState.errors.secret_number_2 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.secret_number_2">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_remote_number_1">リモートID①</label>
							<div class="uk-form-controls">
								<input id="create_form_remote_number_1" class="uk-input" name="remote_number_1" type="text" placeholder="リモートID①を入力してください">
								<template v-if="typeof this.createFormState.errors.remote_number_1 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.remote_number_1">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_remote_number_2">リモートID②</label>
							<div class="uk-form-controls">
								<input id="create_form_remote_number_2" class="uk-input" name="remote_number_2" type="text" placeholder="リモートID②を入力してください">
								<template v-if="typeof this.createFormState.errors.remote_number_2 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.remote_number_2">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="create_form_remote_number_3">リモートID③</label>
							<div class="uk-form-controls">
								<input id="create_form_remote_number_3" class="uk-input" name="remote_number_3" type="text" placeholder="リモートID③を入力してください">
								<template v-if="typeof this.createFormState.errors.remote_number_3 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.remote_number_3">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>

						<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveCreateForm">追加</button>
					</div>
				</form>
			</div>
		</div>
		<!--/ CreateFormDialog -->
		<!-- EditFormDialog -->
		<div id="edit_form_dialog" uk-modal>
			<div class="uk-modal-dialog uk-modal-body">
				<div class="uk-overflow-hidden">
					<div class="uk-align-left">
						<h2 class="uk-modal-title">編集</h2>
					</div>
					<div class="uk-align-right">
						<button id="edit_form_dialog_close" class="uk-icon-button" type="button" uk-icon="close"></button>
					</div>
				</div>
				<form id="edit_form">
					<div class="uk-form-horizontal">
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_name">店舗名 (必須)</label>
							<div class="uk-form-controls">
								<input id="edit_form_name" class="uk-input" name="name" type="text" placeholder="店舗名を入力してください" maxlength="20">
								<template v-if="typeof this.createFormState.errors.name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_code">店舗コード (必須)</label>
							<div class="uk-form-controls">
								<template v-if="APP_NAME == 'rfms'">
									<input id="edit_form_code" class="uk-input" name="code" type="text" placeholder="店舗コードを入力してください" maxlength="4">
								</template>
								<template v-else>
									<input id="edit_form_code" class="uk-input" name="code" type="text" placeholder="店舗コードを入力してください" maxlength="4" disabled="disabled">
								</template>
								<template v-if="typeof this.createFormState.errors.code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_jurisdiction_name">ドコモ管轄</label>
							<div class="uk-form-controls">
								<input id="edit_form_jurisdiction_name" class="uk-input" name="jurisdiction_name" type="text" placeholder="ドコモ管轄を入力してください">
								<template v-if="typeof this.createFormState.errors.jurisdiction_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.jurisdiction_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_jurisdiction_code">ドコモ管轄コード</label>
							<div class="uk-form-controls">
								<input id="edit_form_jurisdiction_code" class="uk-input" name="jurisdiction_code" type="text" placeholder="ドコモ管轄コードを入力してください">
								<template v-if="typeof this.createFormState.errors.jurisdiction_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.jurisdiction_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_area_name">エリア名</label>
							<div class="uk-form-controls">
								<input id="edit_form_area_name" class="uk-input" name="area_name" type="text" placeholder="エリア名を入力してください">
								<template v-if="typeof this.createFormState.errors.area_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.area_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_area_code">エリアコード</label>
							<div class="uk-form-controls">
								<input id="edit_form_area_code" class="uk-input" name="area_code" type="text" placeholder="エリアコードを入力してください">
								<template v-if="typeof this.createFormState.errors.area_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.area_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_branch_name">支店名</label>
							<div class="uk-form-controls">
								<input id="edit_form_branch_name" class="uk-input" name="branch_name" type="text" placeholder="支店名を入力してください">
								<template v-if="typeof this.createFormState.errors.branch_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.branch_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_branch_code">支店コード</label>
							<div class="uk-form-controls">
								<input id="edit_form_branch_code" class="uk-input" name="branch_code" type="text" placeholder="支店コードを入力してください">
								<template v-if="typeof this.createFormState.errors.branch_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.branch_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_department_name">部門名</label>
							<div class="uk-form-controls">
								<input id="edit_form_department_name" class="uk-input" name="department_name" type="text" placeholder="部門名を入力してください">
								<template v-if="typeof this.createFormState.errors.department_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.department_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_department_code">部門コード</label>
							<div class="uk-form-controls">
								<input id="edit_form_department_code" class="uk-input" name="department_code" type="text" placeholder="部門コードを入力してください">
								<template v-if="typeof this.createFormState.errors.department_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.department_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_division_name">部名</label>
							<div class="uk-form-controls">
								<input id="edit_form_division_name" class="uk-input" name="division_name" type="text" placeholder="部名を入力してください">
								<template v-if="typeof this.createFormState.errors.division_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.division_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_division_code">部コード</label>
							<div class="uk-form-controls">
								<input id="edit_form_division_code" class="uk-input" name="division_code" type="text" placeholder="部コードを入力してください">
								<template v-if="typeof this.createFormState.errors.division_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.division_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin">
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="edit_form_section_name">課名</label>
								<div class="uk-form-controls">
									<input id="edit_form_section_name" class="uk-input" name="section_name" type="text" placeholder="課名を入力してください">
									<template v-if="typeof this.createFormState.errors.section_name != undefined">
										<template v-for="(error,index) in this.createFormState.errors.section_name">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
							<div class="uk-margin uk-clearfix">
								<label class="uk-form-label" for="edit_form_section_code">課コード</label>
								<div class="uk-form-controls">
									<input id="edit_form_section_code" class="uk-input" name="section_code" type="text" placeholder="課コードを入力してください">
									<template v-if="typeof this.createFormState.errors.section_code != undefined">
										<template v-for="(error,index) in this.createFormState.errors.section_code">
											<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
										</template>
									</template>
								</div>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_am_area_name">AMエリア</label>
							<div class="uk-form-controls">
								<input id="edit_form_am_area_name" class="uk-input" name="am_area_name" type="text" placeholder="AMエリア名を入力してください">
								<template v-if="typeof this.createFormState.errors.am_area_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.am_area_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_am_area_code">AMエリアコード</label>
							<div class="uk-form-controls">
								<input id="edit_form_am_area_code" class="uk-input" name="am_area_code" type="text" placeholder="AMエリアコードを入力してください">
								<template v-if="typeof this.createFormState.errors.am_area_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.am_area_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_company_name">会社名</label>
							<div class="uk-form-controls">
								<input id="edit_form_company_name" class="uk-input" name="company_name" type="text" placeholder="会社名を入力してください">
								<template v-if="typeof this.createFormState.errors.company_name != undefined">
									<template v-for="(error,index) in this.createFormState.errors.company_name">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_company_code">会社コード</label>
							<div class="uk-form-controls">
								<input id="edit_form_company_code" class="uk-input" name="company_code" type="text" placeholder="会社コードを入力してください">
								<template v-if="typeof this.createFormState.errors.company_code != undefined">
									<template v-for="(error,index) in this.createFormState.errors.company_code">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_admin_staff_number">管理者ID (必須)</label>
							<div class="uk-form-controls">
								<input id="edit_form_admin_staff_number" class="uk-input" name="admin_staff_number" type="text" placeholder="管理者IDを入力してください">
								<template v-if="typeof this.createFormState.errors.admin_staff_number != undefined">
									<template v-for="(error,index) in this.createFormState.errors.admin_staff_number">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_business_time_start">営業開始時間 (平日)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="edit_form_business_time_start" v-model="edit_form_business_time_start" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="edit_form_business_time_start" v-model="edit_form_business_time_start" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.business_time_start != undefined">
									<template v-for="(error,index) in this.createFormState.errors.business_time_start">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_business_time_end">営業終了時間 (平日)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="edit_form_business_time_end" v-model="edit_form_business_time_end" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="edit_form_business_time_end" v-model="edit_form_business_time_end" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.business_time_end != undefined">
									<template v-for="(error,index) in this.createFormState.errors.business_time_end">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_wn_business_time_start">営業開始時間 (土日祝)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="edit_form_wn_business_time_start" v-model="edit_form_wn_business_time_start" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="edit_form_wn_business_time_start" v-model="edit_form_wn_business_time_start" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.wn_business_time_start != undefined">
									<template v-for="(error,index) in this.createFormState.errors.wn_business_time_start">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_wn_business_time_end">営業終了時間 (土日祝)</label>
							<div class="uk-form-controls">
								<template v-if="isMobile()">
									<el-time-picker id="edit_form_wn_business_time_end" v-model="edit_form_wn_business_time_end" format="HH:mm" :editable="false" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-else>
									<el-time-picker id="edit_form_wn_business_time_end" v-model="edit_form_wn_business_time_end" format="HH:mm" :clearable="false" :picker-options="time_picker_options" @change="changeEditTime"></el-time-picker>
								</template>
								<template v-if="typeof this.createFormState.errors.wn_business_time_end != undefined">
									<template v-for="(error,index) in this.createFormState.errors.wn_business_time_end">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_secret_number_1">連絡先（裏番）</label>
							<div class="uk-form-controls">
								<input id="edit_form_secret_number_1" class="uk-input" name="secret_number_1" type="text" placeholder="連絡先（裏番）を入力してください">
								<template v-if="typeof this.createFormState.errors.secret_number_1 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.secret_number_1">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_secret_number_2">連絡先（その他）</label>
							<div class="uk-form-controls">
								<input id="edit_form_secret_number_2" class="uk-input" name="secret_number_2" type="text" placeholder="連絡先（その他）を入力してください">
								<template v-if="typeof this.createFormState.errors.secret_number_2 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.secret_number_2">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_remote_number_1">リモートID①</label>
							<div class="uk-form-controls">
								<input id="edit_form_remote_number_1" class="uk-input" name="remote_number_1" type="text" placeholder="リモートID①を入力してください">
								<template v-if="typeof this.createFormState.errors.remote_number_1 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.remote_number_1">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_remote_number_2">リモートID②</label>
							<div class="uk-form-controls">
								<input id="edit_form_remote_number_2" class="uk-input" name="remote_number_2" type="text" placeholder="リモートID②を入力してください">
								<template v-if="typeof this.createFormState.errors.remote_number_2 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.remote_number_2">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<div class="uk-margin uk-clearfix">
							<label class="uk-form-label" for="edit_form_remote_number_3">リモートID③</label>
							<div class="uk-form-controls">
								<input id="edit_form_remote_number_3" class="uk-input" name="remote_number_3" type="text" placeholder="リモートID③を入力してください">
								<template v-if="typeof this.createFormState.errors.remote_number_3 != undefined">
									<template v-for="(error,index) in this.createFormState.errors.remote_number_3">
										<p class="uk-alert-danger uk-padding-small" :key="index">{{ error }}</p>
									</template>
								</template>
							</div>
						</div>
						<button class="uk-width-1-1@l uk-button uk-button-large uk-button-primary" type="button" @click="saveEditForm">保存</button>
					</div>
				</form>
			</div>
		</div>
		<!--/ EditFormDialog -->
	</div>
</template>

<script>
	import StaffAuth from '@/api/StaffAuth'
	import Shop from '@/api/Shop'
	import Role from '@/api/Role'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'
	// import VueTimepicker from 'vue2-timepicker'

	export default {
		name: 'MainOfficeShopMasterPage',
		components: {},
		comments: [],
		data () {
			return {
				create_form_business_time_start: moment().hour(0).minutes(0),
				create_form_business_time_end: moment().hour(0).minutes(0),
				create_form_wn_business_time_start: moment().hour(0).minutes(0),
				create_form_wn_business_time_end: moment().hour(0).minutes(0),
				edit_form_business_time_start: moment().hour(0).minutes(0),
				edit_form_business_time_end: moment().hour(0).minutes(0),
				edit_form_wn_business_time_start: moment().hour(0).minutes(0),
				edit_form_wn_business_time_end: moment().hour(0).minutes(0),
				need_confirm_alert: false,
				shops: [],
				createFormState: {
					errors: []
				},
				time_picker_options: {
					format: 'HH:mm'
				}
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		computed: {
			APP_NAME () {
				return APP_NAME
			}
		},
		methods: {
			showEditDialog: function (id) {
				$('#edit_form_dialog').data('id', id)

				let self = this
				let params = new URLSearchParams()
				params.append('id', id)

				Shop.one(params).then(function (response) {
					let data = response.data.data

					self.edit_form_business_time_start = moment('2019-01-01 ' + data.business_time_start)

					self.edit_form_business_time_end = moment('2019-01-01 ' + data.business_time_end)

					self.edit_form_wn_business_time_start = moment('2019-01-01 ' + data.wn_business_time_start)

					self.edit_form_wn_business_time_end = moment('2019-01-01 ' + data.wn_business_time_end)

					$('#edit_form [name="name"]').val(data.name)
					$('#edit_form [name="code"]').val(data.code)
					$('#edit_form [name="jurisdiction_name"]').val(data.jurisdiction_name)
					$('#edit_form [name="jurisdiction_code"]').val(data.jurisdiction_code)
					$('#edit_form [name="area_name"]').val(data.area_name)
					$('#edit_form [name="area_code"]').val(data.area_code)
					$('#edit_form [name="branch_name"]').val(data.branch_name)
					$('#edit_form [name="branch_code"]').val(data.branch_code)
					$('#edit_form [name="department_name"]').val(data.department_name)
					$('#edit_form [name="department_code"]').val(data.department_code)
					$('#edit_form [name="division_name"]').val(data.division_name)
					$('#edit_form [name="division_code"]').val(data.division_code)
					$('#edit_form [name="section_name"]').val(data.section_name)
					$('#edit_form [name="section_code"]').val(data.section_code)
					$('#edit_form [name="am_area_name"]').val(data.am_area_name)
					$('#edit_form [name="am_area_code"]').val(data.am_area_code)
					$('#edit_form [name="company_name"]').val(data.company_name)
					$('#edit_form [name="company_code"]').val(data.company_code)
					$('#edit_form [name="admin_staff_number"]').val(data.admin_staff_number)

					$('#edit_form [name="secret_number_1"]').val(data.secret_number_1)
					$('#edit_form [name="secret_number_2"]').val(data.secret_number_2)
					$('#edit_form [name="remote_number_1"]').val(data.remote_number_1)
					$('#edit_form [name="remote_number_2"]').val(data.remote_number_2)
					$('#edit_form [name="remote_number_3"]').val(data.remote_number_3)

					UIkit.modal($('#edit_form_dialog'), {container: '#app div', bgClose: false}).show()
				})
			},
			saveEditForm: function () {
				let id = $('#edit_form_dialog').data('id')

				let params = new URLSearchParams()
				params.append('id', id)

				let name = $('#edit_form [name="name"]').val()
				let code = $('#edit_form [name="code"]').val()
				let jurisdiction_name = $('#edit_form [name="jurisdiction_name"]').val()
				let jurisdiction_code = $('#edit_form [name="jurisdiction_code"]').val()
				let area_name = $('#edit_form [name="area_name"]').val()
				let area_code = $('#edit_form [name="area_code"]').val()
				let branch_name = $('#edit_form [name="branch_name"]').val()
				let branch_code = $('#edit_form [name="branch_code"]').val()
				let department_name = $('#edit_form [name="department_name"]').val()
				let department_code = $('#edit_form [name="department_code"]').val()
				let division_name = $('#edit_form [name="division_name"]').val()
				let division_code = $('#edit_form [name="division_code"]').val()
				let section_name = $('#edit_form [name="section_name"]').val()
				let section_code = $('#edit_form [name="section_code"]').val()
				let am_area_name = $('#edit_form [name="am_area_name"]').val()
				let am_area_code = $('#edit_form [name="am_area_code"]').val()
				let company_name = $('#edit_form [name="company_name"]').val()
				let company_code = $('#edit_form [name="company_code"]').val()
				let admin_staff_number = $('#edit_form [name="admin_staff_number"]').val()
				let business_time_start = moment(this.edit_form_business_time_start).format('HH:mm')
				let business_time_end = moment(this.edit_form_business_time_end).format('HH:mm')
				let wn_business_time_start = moment(this.edit_form_wn_business_time_start).format('HH:mm')
				let wn_business_time_end = moment(this.edit_form_wn_business_time_end).format('HH:mm')

				let secret_number_1 = $('#edit_form [name="secret_number_1"]').val()
				let secret_number_2 = $('#edit_form [name="secret_number_2"]').val()
				let remote_number_1 = $('#edit_form [name="remote_number_1"]').val()
				let remote_number_2 = $('#edit_form [name="remote_number_2"]').val()
				let remote_number_3 = $('#edit_form [name="remote_number_3"]').val()

				params.append('name', name)
				params.append('code', code)

				if (jurisdiction_name != null) {
					params.append('jurisdiction_name', jurisdiction_name)
				}
				if (jurisdiction_code != null) {
					params.append('jurisdiction_code', jurisdiction_code)
				}
				if (area_name != null) {
					params.append('area_name', area_name)
				}
				if (area_code != null) {
					params.append('area_code', area_code)
				}
				if (branch_name != null) {
					params.append('branch_name', branch_name)
				}
				if (branch_code != null) {
					params.append('branch_code', branch_code)
				}
				if (department_name != null) {
					params.append('department_name', department_name)
				}
				if (department_code != null) {
					params.append('department_code', department_code)
				}
				if (division_name != null) {
					params.append('division_name', division_name)
				}
				if (division_code != null) {
					params.append('division_code', division_code)
				}
				if (section_name != null) {
					params.append('section_name', section_name)
				}
				if (section_code != null) {
					params.append('section_code', section_code)
				}
				if (am_area_name != null) {
					params.append('am_area_name', am_area_name)
				}
				if (am_area_code != null) {
					params.append('am_area_code', am_area_code)
				}
				if (company_name != null) {
					params.append('company_name', company_name)
				}
				if (company_code != null) {
					params.append('company_code', company_code)
				}
				if (admin_staff_number != null) {
					params.append('admin_staff_number', admin_staff_number)
				}
				if (business_time_start != null) {
					params.append('business_time_start', business_time_start)
				}
				if (business_time_end != null) {
					params.append('business_time_end', business_time_end)
				}
				if (wn_business_time_start != null) {
					params.append('wn_business_time_start', wn_business_time_start)
				}
				if (wn_business_time_end != null) {
					params.append('wn_business_time_end', wn_business_time_end)
				}

				if (secret_number_1 != null) {
					params.append('secret_number_1', secret_number_1)
				}
				if (secret_number_2 != null) {
					params.append('secret_number_2', secret_number_2)
				}
				if (remote_number_1 != null) {
					params.append('remote_number_1', remote_number_1)
				}
				if (remote_number_2 != null) {
					params.append('remote_number_2', remote_number_2)
				}
				if (remote_number_3 != null) {
					params.append('remote_number_3', remote_number_3)
				}

				Shop.update(params).then(function (response) {
					alert('保存完了')
					location.reload()
				}).catch(function (error) {
					self.createFormState.errors = error.response.data.errors
				})
			},
			returnButton: function () {
				if ($('.data_row_before_save').length > 0) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						this.$router.push('/main_office')
						location.reload()
					}
				} else {
					this.$router.push('/main_office')
					location.reload()
				}
			},
			clickLogoutButton () {
				let self = this

				// StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/main_office/login')
								location.reload()
							})
						// })
					// })
				// })
			},
			bulkCheckAction () {
				let checked = $('#bulk_check_action').prop('checked')
				$('#shop_table tbody .data_row [name="status"]').prop('checked', checked)
				$('#shop_table tbody .data_row').addClass('data_row_before_save')
			},
			saveEditShop () {
				let self = this
				let length = $('#shop_table .data_row_before_save').length

				$('#shop_table .data_row_before_save').each(function (i) {
					let index = i

					let id = $(this).data('id')
					let status = 1

					if ($(this).find('[name="status"]').prop('checked')) {
						status = 0
					}

					let params = new URLSearchParams()
					params.append('id', id)
					params.append('status', status)

					Shop.update(params).then(function () {
						if (i + 1 == length) {
							alert('保存完了')
							location.reload()
						}
					})
				})
			},
			loadShops () {
				let self = this

				Shop.all().then(function (response) {
					self.shops = response.data.data
				})
			},
			saveCreateForm () { // ダイアログ保存
				let self = this

				let name = $('#create_form [name="name"]').val()
				let code = $('#create_form [name="code"]').val()
				let jurisdiction_name = $('#create_form [name="jurisdiction_name"]').val()
				let jurisdiction_code = $('#create_form [name="jurisdiction_code"]').val()
				let area_name = $('#create_form [name="area_name"]').val()
				let area_code = $('#create_form [name="area_code"]').val()
				let branch_name = $('#create_form [name="branch_name"]').val()
				let branch_code = $('#create_form [name="branch_code"]').val()
				let department_name = $('#create_form [name="department_name"]').val()
				let department_code = $('#create_form [name="department_code"]').val()
				let division_name = $('#create_form [name="division_name"]').val()
				let division_code = $('#create_form [name="division_code"]').val()
				let section_name = $('#create_form [name="section_name"]').val()
				let section_code = $('#create_form [name="section_code"]').val()
				let am_area_name = $('#create_form [name="am_area_name"]').val()
				let am_area_code = $('#create_form [name="am_area_code"]').val()
				let company_name = $('#create_form [name="company_name"]').val()
				let company_code = $('#create_form [name="company_code"]').val()
				let admin_staff_number = $('#create_form [name="admin_staff_number"]').val()
				let business_time_start = moment(this.create_form_business_time_start).format('HH:mm')
				let business_time_end = moment(this.create_form_business_time_end).format('HH:mm')
				let wn_business_time_start = moment(this.create_form_wn_business_time_start).format('HH:mm')
				let wn_business_time_end = moment(this.create_form_wn_business_time_end).format('HH:mm')

				let secret_number_1 = $('#create_form [name="secret_number_1"]').val()
				let secret_number_2 = $('#create_form [name="secret_number_2"]').val()
				let remote_number_1 = $('#create_form [name="remote_number_1"]').val()
				let remote_number_2 = $('#create_form [name="remote_number_2"]').val()
				let remote_number_3 = $('#create_form [name="remote_number_3"]').val()

				let params = new URLSearchParams()
				params.append('name', name)
				params.append('code', code)

				if (jurisdiction_name != null) {
					params.append('jurisdiction_name', jurisdiction_name)
				}
				if (jurisdiction_code != null) {
					params.append('jurisdiction_code', jurisdiction_code)
				}
				if (area_name != null) {
					params.append('area_name', area_name)
				}
				if (area_code != null) {
					params.append('area_code', area_code)
				}
				if (branch_name != null) {
					params.append('branch_name', branch_name)
				}
				if (branch_code != null) {
					params.append('branch_code', branch_code)
				}
				if (department_name != null) {
					params.append('department_name', department_name)
				}
				if (department_code != null) {
					params.append('department_code', department_code)
				}
				if (division_name != null) {
					params.append('division_name', division_name)
				}
				if (division_code != null) {
					params.append('division_code', division_code)
				}
				if (section_name != null) {
					params.append('section_name', section_name)
				}
				if (section_code != null) {
					params.append('section_code', section_code)
				}
				if (am_area_name != null) {
					params.append('am_area_name', am_area_name)
				}
				if (am_area_code != null) {
					params.append('am_area_code', am_area_code)
				}
				if (company_name != null) {
					params.append('company_name', company_name)
				}
				if (company_code != null) {
					params.append('company_code', company_code)
				}
				if (admin_staff_number != null) {
					params.append('admin_staff_number', admin_staff_number)
				}
				if (business_time_start != null) {
					params.append('business_time_start', business_time_start)
				}
				if (business_time_end != null) {
					params.append('business_time_end', business_time_end)
				}
				if (wn_business_time_start != null) {
					params.append('wn_business_time_start', wn_business_time_start)
				}
				if (wn_business_time_end != null) {
					params.append('wn_business_time_end', wn_business_time_end)
				}

				if (secret_number_1 != null) {
					params.append('secret_number_1', secret_number_1)
				}
				if (secret_number_2 != null) {
					params.append('secret_number_2', secret_number_2)
				}
				if (remote_number_1 != null) {
					params.append('remote_number_1', remote_number_1)
				}
				if (remote_number_2 != null) {
					params.append('remote_number_2', remote_number_2)
				}
				if (remote_number_3 != null) {
					params.append('remote_number_3', remote_number_3)
				}

				Shop.create(params).then(function (response) {
					alert('保存完了')
					location.reload()
				}).catch(function (error) {
					self.createFormState.errors = error.response.data.errors
				})
			},
			showCreateFormDialog () { // ダイアログ表示
				UIkit.modal($('#create_form_dialog'), {container: '#app div', bgClose: false}).show()
			},
			registerDataChangeEvent () { // データを変更した時のイベント登録
				$(document).on('change', '#shop_table .data_row .uk-checkbox', function () {
					if ($(this).text() != $(this).data('first')) {
						$(this).closest('.data_row').addClass('data_row_before_save')
					}
				})
			},
			isMobile () {
				let ua = navigator.userAgent

				if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 || ua.indexOf('Mobile') > 0) {
					return true
				} else {
					return false
				}
			},
			changeCreateTime () {
				let self = this
				
				if (self.create_form_business_time_start == null) {
					self.create_form_business_time_start = moment().hour(0).minutes(0)
				}
				if (self.create_form_business_time_end == null) {
					self.create_form_business_time_end = moment().hour(0).minutes(0)
				}
				if (self.create_form_wn_business_time_start == null) {
					self.create_form_wn_business_time_start = moment().hour(0).minutes(0)
				}
				if (self.create_form_wn_business_time_end == null) {
					self.create_form_wn_business_time_end = moment().hour(0).minutes(0)
				}
			},
			changeEditTime () {
				let self = this
				
				if (self.edit_form_business_time_start == null) {
					self.edit_form_business_time_start = moment().hour(0).minutes(0)
				}
				if (self.edit_form_business_time_end == null) {
					self.edit_form_business_time_end = moment().hour(0).minutes(0)
				}
				if (self.edit_form_wn_business_time_start == null) {
					self.edit_form_wn_business_time_start = moment().hour(0).minutes(0)
				}
				if (self.edit_form_wn_business_time_end == null) {
					self.edit_form_wn_business_time_end = moment().hour(0).minutes(0)
				}
			}
		},
		created () {
			this.loadShops()
		},
		beforeMount () {
		},
		mounted () {
			this.registerDataChangeEvent()

			let self = this

			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_main_office != true) { // 権限が無い場合
					self.$router.push('/')
				}
			})

			$('#create_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#create_form_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#create_form_dialog')).hide()
				}
			})

			$('#edit_form_dialog_close').on('click', function () {
				if (self.need_confirm_alert) {
					if (window.confirm('保存されておりませんが、よろしいですか')) {
						UIkit.modal($('#edit_form_dialog')).hide()
						self.need_confirm_alert = false
					}
				} else {
					UIkit.modal($('#edit_form_dialog')).hide()
				}
			})

			$('#create_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})

			$('#edit_form_dialog').on('change', function () {
				self.need_confirm_alert = true
			})
		},
		beforeRouteLeave (to, from, next) {
			$('.uk-open').remove()
			next()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	#shop_table {
		width: 100%;

		thead {
			tr {
				th {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
					white-space: nowrap;
				}
			}
		}

		tbody {
			tr {
				td {
					border: solid 1px #DDD;
					text-align: center;
					vertical-align: middle;
					white-space: nowrap;

					&:focus {
						background: #FFF;
					}
				}
			}
		}

		.data_row_before_save {
			background: #FFFDE6;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/page/MainOfficeShopMasterPage.vue